import { useFieldInfo, useTsController } from "@ts-react/form";
import React, { useId } from "react";
import type { TextInput } from "react-native";
import type { InputProps } from "tamagui";
import { BentoInput } from "../bento/inputParts";
import { Fieldset } from "./Fieldset";
import { FormError } from "./FormError";
import { useFormFieldOptions } from "./FormFieldOptionsProvider";
export type InputFieldProps = Pick<InputProps, "size" | "autoFocus" | "disabled" | "onSubmitEditing" | "inputMode" | "keyboardType" | "maxLength" | "placeholder" | "returnKeyType">;
export const InputField = (props: InputFieldProps & {
  formatInput?: (text: string) => string;
}) => {
  const {
    field,
    error,
    formState: {
      isSubmitting
    }
  } = useTsController<string>();
  const {
    formatInput,
    size,
    disabled: disabledProp,
    ...inputProps
  } = props;
  const {
    label,
    placeholder,
    isOptional
  } = useFieldInfo();
  const {
    hideOptionalLabel
  } = useFormFieldOptions();
  const inputRef = React.useRef<TextInput | null>(null);
  const id = useId();
  const inputId = `${id}_input`;
  const disabled = isSubmitting || disabledProp;
  const setInputFocus = () => {
    if (inputRef.current && !inputRef.current.isFocused()) {
      inputRef.current.focus();
    }
  };
  return <Fieldset data-sentry-element="Fieldset" data-sentry-component="InputField" data-sentry-source-file="InputField.tsx">
      <BentoInput theme={error ? "red_alt2" : "granted"} size={size || "$4"} key={inputId} data-sentry-element="BentoInput" data-sentry-source-file="InputField.tsx">
        {label ? <BentoInput.Label theme="alt1" htmlFor={inputId} flexGrow={0} alignSelf="flex-start">
            {label}
            {isOptional && !hideOptionalLabel ? ` (Optional)` : null}
          </BentoInput.Label> : null}
        <BentoInput.Box onPress={() => setInputFocus()} disabled={disabled} data-sentry-element="BentoInput.Box" data-sentry-source-file="InputField.tsx">
          <BentoInput.Area id={inputId} hasLabel={!!label} placeholder={placeholder} overflow="hidden" flex={1}
        // Empty string instead of undefined so that the component
        // does not transition from "unmanaged" to "managed" (which
        // displays an error log in the web console).
        value={field.value ?? ""} onChangeText={text => {
          field.onChange(formatInput?.(text) ?? text);
        }} onBlur={field.onBlur} disabled={disabled} ref={ref => {
          field.ref(ref);
          inputRef.current = ref;
        }} {...inputProps} data-sentry-element="BentoInput.Area" data-sentry-source-file="InputField.tsx" />
        </BentoInput.Box>
        <FormError errorMessage={error?.errorMessage} data-sentry-element="FormError" data-sentry-source-file="InputField.tsx" />
      </BentoInput>
    </Fieldset>;
};